/**
 * Start date used for adding a card
 */
import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';

import { cardSpecPropType } from 'prop-validators';
import { getFormattedExpirationDate } from './date-utils';

const STYLES = {
	logoWrapper: {
		height: '100%',
		position: 'absolute',
		top: 0,
		right: 0,
	},
	dropdown: {
		padding: 0,
		textIndent: 10,
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none',
		height: 42,
	},
	dropdownLeft: {
		borderRadius: '5px 0px 0px 5px',
		borderRight: 0,
	},
	dropdownRight: {
		borderRadius: '0px 5px 5px 0px',
	},
	arrow: {
		position: 'absolute',
		right: 10,
		top: 20,
		cursor: 'default',
	},
	logo: {
		display: 'inline-block',
		marginTop: 12,
		marginRight: 2,
	},
	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out',
		width: '200%'
	}
};

class StartDate extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showIsRequiredError: false,
			lastCharacterIsSlash: false,
			startMonth: '',
			startYear: '',
			allMonths: this.getAllMonths(),
			allYears: this.getEligibleYears(),
			// startMonth: this.props.startMonth,
			// startYear: this.props.startYear,
		};
	}

	getAllMonths() {
		return [...Array(12)].map((_, i) => {
			let month = (i + 1).toString();
			if (month.length === 1) {
				return '0' + month
			}
			return month;
		});
	}

	getEligibleYears() {
		const currentYear = new Date().getFullYear();
		return [...Array(10)].map((_, i) => currentYear - i );
	}

	/**
	 * Handle changing start month
	 * @return {String} month - the formatted month
	 */
	handleMonthChange = (event) => {
		const month = event.target.value;
		this.setState({ startMonth: month });
		this.props.handleChange({startMonth: month, startYear: this.state.startYear});
		return month;
	}

	/**
	 * Handle changing start year
	 * Use the getFormattedExpirationDate util to format the date
	 * @return {String} start - the formatted year
	 */
	handleYearChange = (event) => {
		let year = event.target.value;
		this.setState({ startYear: year });
		this.props.handleChange({startMonth: this.state.startMonth, startYear: year})
		return year;
	}

	render() {
		let { errorMessage } = this.props;
		let errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage) {
			errorStyles = { height: '100%' };
		}
		return (
			<div style={{ marginTop: 10 }}>
				{
					// <legend style={{ marginBottom: '5px', textAlign: 'left', fontWeight: 'bold', 'fontSize': '0.9375rem' }}>Starts</legend>
				}
				<div>
					<div className={classNames({
                        'vx_has-error-with-message': errorMessage,
                        "ppvx_field--error": errorMessage
                    })} style={{ borderRadius: '5px 0px 0px 5px', position: 'relative', width:'50%', float: 'left'}}>
						<div style={{ position: 'relative' }}>
							<select id="cardTypeSelection"
								style={{...STYLES.dropdown, ...STYLES.dropdownLeft}}
									className="ppvx_dropdown__control"
									value={this.state.startMonth}
									onChange={this.handleMonthChange}>
									<option value="" disabled>{this.props.labelMonth}</option>
									{this.state.allMonths.map((item) => (
										<option key={item} value={item}>{item}</option>
									))}
							</select>
							<label htmlFor="MM" style={STYLES.arrow} className={`icon icon-arrow-down-small`}></label>
							<div className={classNames({
								'vx_form-control-message': errorMessage
								})} style={{ ...STYLES.errorMessage, errorStyles }}>
								{errorMessage}
							</div>
						</div>
					</div>
					<div className={classNames({
                        'vx_has-error-with-message': errorMessage,
                        "ppvx_field--error": errorMessage
                    })} style={{ position: 'relative', width:'50%', float: 'left' }}>
						<div style={{ position: 'relative' }}>
							<select id="cardTypeSelection"
									style={{...STYLES.dropdown, ...STYLES.dropdownRight}}
									className="ppvx_dropdown__control"
									value={this.state.startYear}
									onChange={this.handleYearChange}>
									<option value="" disabled>{this.props.labelYear}</option>
									{this.state.allYears.map((item) => (
										<option key={item} value={item}>{item}</option>
									))}
							</select>
							<label htmlFor="YY" style={STYLES.arrow} className={`icon icon-arrow-down-small`}></label>
						</div>
					</div>
				</div>
			</div>
		);
	}
};

StartDate.propTypes = {
	cardSpec: cardSpecPropType,
	label: PropTypes.string,
	helpText: PropTypes.string,
	errorMessage: PropTypes.string,
	handleChange: PropTypes.func,
	dir: PropTypes.string,
};

export default StartDate;
